<template>
  <div>
    <h1>Cigarette Pricing For {{ls.location}}</h1>
    <!-- <select v-model="ls.location">
      
      <option v-for="l in locations" :key="l" v-bind:value="l">{{l}}</option>
    </select> -->

    Select Location: <LocationSelector v-model="ls.location" />
    
    <h5>Inventory</h5>
    <InventoryPricingCRUD :location="ls.location" :departments="departments"/>
    
    <!-- <h5>Categories</h5>
    <CategoriesCRUD :location='ls.location'/>
    
    <h5>Departments</h5>
    <DepartmentsCRUD v-model='departments' :location='ls.location'/> -->

  </div>
</template>

<script>
import InventoryPricingCRUD from '@/pages/Inventory/Components/InventoryPricingCRUD.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'
// import LocationSelector from '@/components/LocationSelector.vue'
export default {
  mixins: [localstorageMixin],
  components : {InventoryPricingCRUD},
  name: 'InventoryPricing',
  data () { return { 
    ls: {
      location: 'RMGB',
    },
    departments: []
    } 
  },
  async created () {
    console.log('router', this.$router)
    console.log('route', this.$route)
    this.loadData();
  },
  watch:{
    "ls.location" : function(){
      console.log("location change")
      this.loadData();
    }
  },
  methods : {
    loadData: function(){
      this.departments = [];
      const options = {attributes:['Dept_ID', 'Description'], where:{SubType:'CIGS'}}
      this.$axios.get(`/api/${this.ls.location}/departments`, {params: options}).then((r)=>{
        this.departments = r.data
      });
    },
  }, 
}
</script>

<style scoped>
  
</style>
